import DailyAdapter from "./providers/DailyAdapter";

/**
 * Cria uma nova instância do provedor de videochamada ativo.
 * Para trocar de provedor: substituir DailyAdapter pela nova implementação.
 */
export function createVideoCallProvider() {
  return new DailyAdapter();
}
